import type { MarketPart } from "@utah-vr/shared";

export async function fetchMarket(): Promise<{ parts: MarketPart[]; updatedAt: number }> {
	const res = await fetch("/api/city/market-prices");
	if (!res.ok) throw new Error(`market fetch failed: ${res.status}`);
	return res.json();
}
